import { useCallback, useEffect, useState } from 'react';
import Title from '../../../componente/cadastro/titulo/index.jsx';
import Description from '../../../componente/cadastro/descricao/index.jsx';
import SearchField from '../../../componente/cadastro/busca/index.jsx';
import AddButton from '../../../componente/cadastro/botaoadd/index.jsx';
import Table from '../../../componente/cadastro/tabela/index.jsx';
import TableTamanho from '../../../componente/cadastro/tabela/index.jsx';
import TableTecido from '../../../componente/cadastro/tabela/index.jsx';
import TableCor from '../../../componente/cadastro/tabela/index.jsx';
import Pagination from '../../../componente/cadastro/paginacao/index.jsx';
import Sidebar from "../../../componente/sidebar/index.jsx";
import "./style.css";
import api from "../../../services/api.js";
import { useAppContext } from "../../context/AppContext.jsx";
import { toast } from 'react-hot-toast';
import Modal from "react-modal";
import ModalFornecedor from "react-modal";
import ModalProduto from "react-modal";
import ModalTamanho from "react-modal";
import ModalTecido from "react-modal";
import ModalCor from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import PopUpTamanho from "../../../componente/popup/index.jsx";
import PopUpTecido from "../../../componente/popup/index.jsx";
import PopUpCor from "../../../componente/popup/index.jsx";
import DuasDatas from '../../../componente/cadastro/duasdatas/index.jsx';
import AutoComplete1 from '../../../componente/cadastro/autocomplete/index.jsx';
import AutoComplete3 from '../../../componente/cadastro/autocomplete/index.jsx';
import Aguarte from "../../../componente/aguarde/index.jsx";
import { usePermissoes } from "../../../componente/permissoes";

Modal.setAppElement("#root");

const OpeEntradaMercadoria = () => {
    const { podeInserir, podeEditar, podeExcluir } = usePermissoes();

    const { DateTime } = require("luxon");
    const [search, setSearch] = useState('');

    const getFirstDayOfMonth = () => {
        const dt = new Date();
        dt.setMonth(dt.getMonth() - 1); // retrocede 1 mês
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-01`;
    };

    // Função para calcular a data atual
    const getCurrentDate = () => {
        const dt = new Date();
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-${dt.getDate().toString().padStart(2, "0")}`;
    };

    const [dt1, setdt1] = useState(getFirstDayOfMonth);
    const [dt2, setdt2] = useState(getCurrentDate);

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        totalPages: 0
    });
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [error, setError] = useState(null);
    const [showform, setshowform] = useState(false);
    const [showformfornecedor, setshowformfornecedor] = useState(false);
    const { accessKey, codassinante, codempresa, codusuario } = useAppContext(); // Acessa os dados do contexto          
    const [novo, setnovo] = useState(false);
    const [novofornecedor, setnovofornecedor] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const columns = [
        { key: 'dtlancamento', title: 'Lançamento', type: 'date' },
        { key: 'nometipo', title: 'Tipo' },
        { key: 'nomefornecedor', title: 'Responsável', responsive: "md" },
        { key: 'qtdeitens', title: 'Qtde Itens' },
    ];

    const menuOptions = [
        { label: "Imprimir", onClick: (item) => Imprimir(item) },
    ];

    //campos
    const [codentrada, setCodEntrada] = useState(0);

    const [qtde, setQtde] = useState(0);
    const [preco, setPreco] = useState(0);
    const [total, setTotal] = useState(0);
    const [codtamanho, setCodTamanho] = useState(0);
    const [listaTamanho, setListaTamanho] = useState([]);
    const [codtecido, setCodTecido] = useState(0);
    const [listaTecido, setListaTecido] = useState([]);
    const [codcor, setCodCor] = useState(0);
    const [listaCor, setListaCor] = useState([]);
    const [codproduto, setCodProduto] = useState(0);
    const [observacao, setObservacao] = useState('');
    const [tipo, setTipo] = useState('P');

    const [abaAtiva, setAbaAtiva] = useState("cabecalho");

    const abas = ["cabecalho", "itens"];
    const progresso = ((abas.indexOf(abaAtiva) + 1) / abas.length) * 100;

    //Campo do Fornecedor
    const [codfornecedor, setCodFornecedor] = useState(0);
    const [tipofornecedor, setTipoFornecedor] = useState("");
    const [nome, setNome] = useState("");
    const [cpf, setCPF] = useState("");
    const [razaosocial, setRazaoSocial] = useState("");
    const [nomefantasia, setNomeFantasia] = useState("");
    const [cnpj, setCNPJ] = useState("");
    const [ie, setIE] = useState("");
    const [cep, setCEP] = useState("");
    const [endereco, setEndereco] = useState("");
    const [numero, setNumero] = useState("");
    const [complemento, setComplemento] = useState("");
    const [bairro, setBairro] = useState("");
    const [cidade, setCidade] = useState("");
    const [uf, setUF] = useState("");
    const [codcidade, setCodCidade] = useState("");
    const [pais, setPais] = useState("");
    const [codpais, setCodPais] = useState("");
    const [telefone, setTelefone] = useState("");
    const [whatsapp, setWhatsApp] = useState("");
    const [email, setEmail] = useState("");

    //Campos de Produto
    const [dataTamanho, setDataTamanho] = useState([]);
    const [dataTecido, setDataTecido] = useState([]);
    const [dataCor, setDataCor] = useState([]);
    const [showformproduto, setshowformproduto] = useState(false);
    const [showformtamanho, setshowformtamanho] = useState(false);
    const [showformtecido, setshowformtecido] = useState(false);
    const [showformcor, setshowformcor] = useState(false);
    const [novoproduto, setnovoproduto] = useState(false);
    const [novotamanho, setnovotamanho] = useState(false);
    const [novotecido, setnovotecido] = useState(false);
    const [novacor, setnovocor] = useState(false);
    const [isOpenTamanho, setIsOpenTamanho] = useState(false);
    const [isOpenTecido, setIsOpenTecido] = useState(false);
    const [isOpenCor, setIsOpenCor] = useState(false);

    const columnsTamanho = [
        { key: 'tamanho', title: 'Tamanho' },
    ];
    const columnsTecido = [
        { key: 'tecido', title: 'Tecido' },
    ];
    const columnsCor = [
        { key: 'cor', title: 'Cor' },
    ];

    //campos    
    const [descricao, setDescricao] = useState("");

    //Campos Tamanho
    const [codtamanhocad, setCodTamanhoCad] = useState(0);
    const [tamanho, setTamanho] = useState("");

    //Campos Preco por Tamanho
    const [codpreco, setCodPreco] = useState(0);
    const [serraria, setSerraria] = useState(0);
    const [montagemgrade, setMontagemGrade] = useState(0);
    const [marcenaria, setMarcenaria] = useState(0);
    const [colagemespuma, setColagemEspuma] = useState(0);
    const [cortetecido, setCorteTecido] = useState(0);
    const [costura, setCostura] = useState(0);
    const [enchimentoalmofada, setEnchimentoAlmofada] = useState(0);
    const [colagemtecido, setColagemTecido] = useState(0);
    const [coberta, setCoberta] = useState(0);
    const [entrega, setEntrega] = useState(0);

    //Campos Tecido
    const [codtecidocad, setCodTecidoCad] = useState(0);
    const [tecido, setTecido] = useState("");

    //Campos Cor
    const [codcorcad, setCodCorCad] = useState(0);
    const [cor, setCor] = useState("");

    const INITIAL_ENTRADA_DATA = {
        codentrada: 0,
        tipo: '',
        dtlancamento: '',
        codfornecedor: 0,
        nomefornecedor: '',
        codusuario: 0,
        codassinante: 0,
        codempresa: 0,
        excluido: "N",
        itens: []
    };
    // estado para a entrada e lista de itens
    const [entradaData, setEntradaData] = useState(INITIAL_ENTRADA_DATA);

    const handleFileUpload = async (event, itemIndex) => {
        const files = event.target.files;
        if (files.length === 0) return;

        try {
            setLoading(true);

            const uploadPromises = Array.from(files).map(async (file) => {
                // Converte o arquivo para Base64
                const base64 = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result.split(",")[1]);
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                });

                const payload = {
                    local: `Estofaria/AnexosItensEntrada/${entradaData.nomefornecedor}/${file.name}`,
                    nome: file.name,
                    base64,
                };

                const response = await api.post("/v1/operacao/upload", payload, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessKey}`,
                    },
                });

                return response.data; // { codigo, nome, url, key }
            });

            const newFiles = await Promise.all(uploadPromises);

            setEntradaData((prev) => {
                const updatedItens = [...prev.itens];
                const currentItem = updatedItens[itemIndex];

                updatedItens[itemIndex] = {
                    ...currentItem,
                    arquivos: [...(currentItem.arquivos || []), ...newFiles],
                };

                return { ...prev, itens: updatedItens };
            });

            alert("Uploads realizados com sucesso!");
        } catch (error) {
            console.error("Erro no upload:", error);
            alert("Erro ao realizar o upload de um ou mais arquivos.");
        } finally {
            setLoading(false);
        }
    };

    const handleOpen = (cad) => {
        setCodEntrada(cad.codentrada);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        handleDelete();
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleTamanhoOpen = (cad) => {
        setCodTamanhoCad(cad.codtamanho);
        setIsOpenTamanho(true);
    };

    const handleTamanhoConfirma = () => {
        setIsOpenTamanho(false);
        handleTamanhoDelete();
    };

    const handleTamanhoClose = () => {
        setIsOpenTamanho(false);
    };

    const handleTecidoOpen = (cad) => {
        setCodTecidoCad(cad.codtecido);
        setIsOpenTecido(true);
    };

    const handleTecidoConfirma = () => {
        setIsOpenTecido(false);
        handleTecidoDelete();
    };

    const handleTecidoClose = () => {
        setIsOpenTecido(false);
    };

    const handleCorOpen = (cad) => {
        setCodCorCad(cad.codcor);
        setIsOpenCor(true);
    };

    const handleCorConfirma = () => {
        setIsOpenCor(false);
        handleCorDelete();
    };

    const handleCorClose = () => {
        setIsOpenCor(false);
    };

    const fetchData = useCallback(async (searchTerm, page, limit) => {
        try {
            setLoading(true);
            setError(null);

            const response = await api.get("/v1/operacao/entrada", {
                params: {
                    busca: searchTerm,
                    page,
                    per_page: limit,
                    codassinante,
                    codempresa,
                    dt1,
                    dt2,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            setData(response.data.data);
            setPagination({
                total: response.data.pagination.Total,
                totalPages: response.data.pagination.TotalPages,
            });
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
            setError("Erro ao carregar os dados. Tente novamente.");
            toast.error("Ocorreu algum erro! ❌");
        } finally {
            setLoading(false);
        }
    }, [codassinante, codempresa, dt1, dt2, accessKey]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            fetchData(search, currentPage, perPage);
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, [search, currentPage, perPage, fetchData, showform]);


    const fetchDataTamanho = async (codigo) => {
        try {
            setLoading2(true);
            setError(null);
            const response = await api.get("v1/cad/produto/tamanho", {
                params: {
                    codproduto: codigo.id // Usa o código recebido por parâmetro
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setDataTamanho(response.data);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const fetchDataTecido = async (codigo) => {
        try {
            setLoading2(true);
            setError(null);
            const response = await api.get("v1/cad/produto/tecido", {
                params: {
                    codproduto: codigo.id // Usa o código recebido por parâmetro
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setDataTecido(response.data);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const fetchDataCor = async (codigo) => {
        try {
            setLoading2(true);
            setError(null);
            const response = await api.get("v1/cad/produto/cor", {
                params: {
                    codproduto: codigo.id // Usa o código recebido por parâmetro
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setDataCor(response.data);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        setCurrentPage(1); // Volta para primeira página ao mudar quantidade
    };

    const handleEdit = async (user) => {
        try {
            setAbaAtiva("cabecalho");
            setLoading(true);
            setError(null);
            setEntradaData(INITIAL_ENTRADA_DATA);

            const response = await api.get("/v1/operacao/entradaum", {
                params: {
                    codentrada: user.codentrada
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            setshowform(true);
            setnovo(false);

            // Ajusta datas para formato yyyy-MM-dd
            const formatDate = (dateStr) =>
                dateStr
                    ? DateTime.fromISO(dateStr).plus({ hours: 3 }).toFormat("yyyy-MM-dd")
                    : "";
            // Monta objeto completo para o ENTRADA            

            const entradaFromApi = {
                codentrada: response.data.codentrada,
                tipo: response.data.tipo || "",
                dtlancamento: formatDate(response.data.dtlancamento),
                excluido: response.data.excluido || "N",
                codassinante: response.data.codassinante,
                codempresa: response.data.codempresa,
                codfornecedor: response.data.codfornecedor,
                nomefornecedor: response.data.nomefornecedor,
                codusuario: response.data.codusuario,
                itens: Array.isArray(response.data.itens)
                    ? response.data.itens.map(it => ({
                        codentradaproduto: it.codentradaproduto,
                        excluido: it.excluido || "N",
                        codproduto: it.codproduto,
                        nomeProduto: it.nomeproduto || "", // já vem do backend
                        qtde: it.qtde,
                        codtamanho: it.codtamanho,
                        tamanho: it.tamanho || "",
                        codtecido: it.codtecido,
                        tecido: it.tecido || "",
                        codcor: it.codcor,
                        cor: it.cor || "",
                        codassinante: it.codassinante,
                        codempresa: it.codempresa,
                        codusuario: it.codusuario,
                        observacao: it.observacao,
                        sku: it.sku,
                        arquivos: Array.isArray(it.arquivos)
                            ? it.arquivos.map(arq => ({
                                codigo: arq.codigo,
                                nome: arq.nome,
                                url: arq.url,
                                key: arq.key,
                                codentradaproduto: arq.codentradaproduto
                            }))
                            : []
                    }))
                    : []
            };

            //console.log("Na edição: "+JSON.stringify(ENTRADAFromApi.faturamento, null, 2));

            // Seta o JSON inteiro no estado
            setEntradaData(entradaFromApi);

        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        try {
            setLoading(true);
            setError(null);
            await api.delete("/v1/operacao/entrada", {
                params: {
                    codentrada,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchData(search, currentPage, perPage);
            toast.success('Excluído com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = async () => {
        setAbaAtiva("cabecalho");
        setLoading(true);
        setError(null);
        setEntradaData(INITIAL_ENTRADA_DATA);

        setshowform(true);
        setnovo(true);

        setCodEntrada(0);

        setEntradaData(prev => ({
            ...prev,
            codfornecedor: 0,
            nomefornecedor: '',
            tipo: 'C'
        }));
    };

    const handleAddNovoProduto = () => {

        if (!codproduto?.id || codproduto.id === 0) {
            alert("Escolha o produto antes de adicionar");
            return;
        }

        if (tipo === 'P' && (codtamanho === 0 || codtecido === 0 || codcor === 0)) {
            alert("Selecione o tamanho, o tecido e a cor");
            return;
        }

        let novoEntrada = { ...entradaData };

        // se for um ENTRADA novo (sem dtlancamento)
        if (!novoEntrada.dtlancamento) {
            const dt1 = new Date();
            const date1 =
                dt1.getFullYear() +
                "-" +
                (dt1.getMonth() + 1).toString().padStart(2, "0") +
                "-" +
                dt1.getDate().toString().padStart(2, "0");

            const time1 =
                dt1.getHours().toString().padStart(2, "0") +
                ":" +
                dt1.getMinutes().toString().padStart(2, "0");

            novoEntrada.dtlancamento = `${date1}T${time1}`;
            novoEntrada.tipo = entradaData.tipo;
            novoEntrada.codassinante = codassinante;
            novoEntrada.codempresa = codempresa;
            novoEntrada.codfornecedor = entradaData.codfornecedor;
            novoEntrada.nomefornecedor = entradaData.nomefornecedor;
            novoEntrada.codusuario = codusuario;
        }

        const asku = tipo === 'P'
            ? "E" + codempresa + "P" + codproduto.id + "TA" + codtamanho + "TE" + codtecido + "C" + codcor
            : "E" + codempresa + "P" + codproduto.id;

        const novoItem = {
            codentradaproduto: 0,
            sku: asku,
            excluido: "N",
            codproduto: codproduto.id,
            nomeProduto: codproduto.label,
            qtde,
            preco,
            total,

            codtamanho,
            tamanho: listaTamanho.find(t => Number(t.codtamanho) === Number(codtamanho))?.tamanho || '',

            codtecido,
            tecido: listaTecido.find(t => Number(t.codtecido) === Number(codtecido))?.tecido || '',

            codcor,
            cor: listaCor.find(c => Number(c.codcor) === Number(codcor))?.cor || '',

            codassinante,
            codempresa,
            codusuario,
            observacao
        };

        novoEntrada.itens = [...novoEntrada.itens, novoItem];

        novoEntrada.total = novoEntrada.itens.reduce((acc, item) => {
            return acc + (Number(item.total) || 0);
        }, 0);

        setEntradaData(novoEntrada);

        setCodProduto({ id: 0, label: '', preco: 0 });
        setQtde(0);
        setPreco(0);
        setTotal(0);
        setCodTamanho(0);
        setCodTecido(0);
        setCodCor(0);
    };

    const handleAddTamanho = () => {
        setshowformtamanho(true);
        setnovotamanho(true);

        setCodTamanho(0);
        setTamanho('');
        setSerraria(0);
        setMontagemGrade(0);
        setMarcenaria(0);
        setColagemEspuma(0);
        setCorteTecido(0);
        setCostura(0);
        setEnchimentoAlmofada(0);
        setColagemTecido(0);
        setCoberta(0);
        setEntrega(0);
    };

    const handleAddTecido = () => {
        setshowformtecido(true);
        setnovotecido(true);

        setCodTecido(0);
        setTecido('');
    };

    const handleAddCor = () => {
        setshowformcor(true);
        setnovocor(true);

        setCodCor(0);
        setCor('');
    };

    const handleTamanhoEdit = async (user) => {
        try {
            setLoading2(true);
            setError(null);
            const response = await api.get("v1/cad/produto/tamanhoum", {
                params: {
                    codtamanho: user.codtamanho
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setshowformtamanho(true);
            setnovotamanho(false);

            setCodTamanho(user.codtamanho);
            setTamanho(response.data.tamanho);

            setCodPreco(response.data.codpreco);
            setSerraria(response.data.serraria);
            setMontagemGrade(response.data.montagemgrade);
            setMarcenaria(response.data.marcenaria);
            setColagemEspuma(response.data.colagemespuma);
            setCorteTecido(response.data.cortetecido);
            setCostura(response.data.costura);
            setEnchimentoAlmofada(response.data.enchimentoalmofada);
            setColagemTecido(response.data.colagemtecido);
            setCoberta(response.data.coberta);
            setEntrega(response.data.entrega);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const handleTamanhoDelete = async () => {
        try {
            setLoading2(true);
            setError(null);
            await api.delete("v1/cad/produto/tamanho", {
                params: {
                    codtamanho: codtamanhocad,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchDataTamanho(codproduto);
            toast.success('Excluído com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const handleTecidoEdit = async (user) => {
        try {
            setLoading2(true);
            setError(null);
            const response = await api.get("v1/cad/produto/tecidoum", {
                params: {
                    codtecido: user.codtecido
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setshowformtecido(true);
            setnovotecido(false);

            setCodTecido(user.codtecido);
            setTecido(response.data.tecido);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const handleTecidoDelete = async () => {
        try {
            setLoading2(true);
            setError(null);
            await api.delete("v1/cad/produto/tecido", {
                params: {
                    codtecido: codtecidocad,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchDataTecido(codproduto);
            toast.success('Excluído com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const handleCorEdit = async (user) => {
        try {
            setLoading2(true);
            setError(null);
            const response = await api.get("v1/cad/produto/corum", {
                params: {
                    codcor: user.codcor
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setshowformcor(true);
            setnovocor(false);

            setCodCor(user.codcor);
            setCor(response.data.cor);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    const handleCorDelete = async () => {
        try {
            setLoading2(true);
            setError(null);
            await api.delete("v1/cad/produto/cor", {
                params: {
                    codcor: codcorcad,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchDataCor(codproduto);
            toast.success('Excluído com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    };

    function Salvar() {
        if (novo) {
            Cadastrar();
        } else {
            Editar();
        }
        setshowform(false);
    }

    function SalvarFornecedor() {
        CadastrarFornecedor();
        setshowformfornecedor(false);
    }

    function SalvarProduto() {
        CadastrarProduto();
        setshowformproduto(false);
    }

    function SalvarTamanho() {
        novotamanho ? CadastrarTamanho() : EditarTamanho();
        setshowformtamanho(false);
    }

    function SalvarTecido() {
        novotecido ? CadastrarTecido() : EditarTecido();
        setshowformtecido(false);
    }

    function SalvarCor() {
        novacor ? CadastrarCor() : EditarCor();
        setshowformcor(false);
    }

    async function Editar() {
        logJsonNodes(entradaData);
        try {
            setLoading(true);
            setError(null);
            await api.put("/v1/operacao/entrada", entradaData, {
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                    "Content-Type": "application/json" // garante envio como JSON
                },
            });
            fetchData(search, currentPage, perPage);
            toast.success('Edição feita com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    async function Cadastrar() {
        try {
            setLoading(true);
            setError(null);

            if (codempresa === 0) {
                alert('Selecione a filial antes!');
                return; // <-- impede que continue para o POST
            }

            await api.post("/v1/operacao/entrada", entradaData, {
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                    "Content-Type": "application/json",
                },
            });

            fetchData(search, currentPage, perPage);
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao cadastrar entrada:', error);
            setError('Erro ao tentar salvar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    async function CadastrarFornecedor() {
        try {
            setLoading(true);
            setError(null);

            if (codempresa === 0) {
                alert('Selecione a filial antes!');
                return; // <-- impede que continue para o POST
            }

            const response = await api.post("v1/cad/fornecedor", {
                tipofornecedor,
                nome,
                cpf,
                razaosocial,
                nomefantasia,
                cnpj,
                ie,
                cep,
                endereco,
                numero,
                complemento,
                bairro,
                cidade,
                uf,
                codcidade,
                pais,
                codpais,
                telefone,
                whatsapp,
                email,
                codempresa,
                excluido: "N",
                codassinante,
                codusuario,
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });

            entradaData.codfornecedor = response.data.codfornecedor;
            entradaData.nomefornecedor = tipofornecedor === 'J' ? razaosocial : nome;

            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    async function CadastrarProduto() {
        try {
            setLoading2(true);
            setError(null);
            const response = await api.post("v1/cad/produto", {
                descricao,
                excluido: "N",
                codassinante,
                codusuario,
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });

            setCodProduto({ id: response.data.codproduto });


            fetchData(search, currentPage, perPage);
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    }

    async function CadastrarTamanho() {
        if (novoproduto) {
            try {
                setLoading2(true);
                setError(null);
                const response = await api.post("v1/cad/produto", {
                    descricao,
                    excluido: "N",
                    codassinante,
                    codusuario,
                },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },

                    });

                setCodProduto({ id: response.data.codproduto });
                setnovo(false);

                toast.success('Registro Salvo com Sucesso!');
            } catch (error) {
                console.error('Erro ao excluir dados:', error);
                setError('Erro ao tentar excluir os dados. Tente novamente.');
                toast.error('Ocorreu algum erro! ❌');
            } finally {
                setLoading2(false);
            }
        }

        try {
            setLoading2(true);
            setError(null);
            await api.post("v1/cad/produto/tamanho", {
                tamanho,
                excluido: "N",
                codproduto,

                serraria,
                montagemgrade,
                marcenaria,
                colagemespuma,
                cortetecido,
                costura,
                enchimentoalmofada,
                colagemtecido,
                coberta,
                entrega
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });

            fetchDataTamanho(codproduto);
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    }

    async function EditarTamanho() {
        try {
            setLoading2(true);
            setError(null);
            await api.put("v1/cad/produto/tamanho", {
                tamanho,
                codtamanho,
                codpreco,
                serraria,
                montagemgrade,
                marcenaria,
                colagemespuma,
                cortetecido,
                costura,
                enchimentoalmofada,
                colagemtecido,
                coberta,
                entrega
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            fetchDataTamanho(codproduto);
            toast.success('Edição feita com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    }

    async function CadastrarTecido() {
        if (novotecido) {
            try {
                setLoading2(true);
                setError(null);
                const response = await api.post("v1/cad/produto", {
                    descricao,
                    excluido: "N",
                    codassinante,
                    codusuario,
                },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },

                    });

                setCodProduto({ id: response.data.codproduto });
                setnovo(false);

                toast.success('Registro Salvo com Sucesso!');
            } catch (error) {
                console.error('Erro ao excluir dados:', error);
                setError('Erro ao tentar excluir os dados. Tente novamente.');
                toast.error('Ocorreu algum erro! ❌');
            } finally {
                setLoading2(false);
            }
        }

        try {
            setLoading2(true);
            setError(null);
            await api.post("v1/cad/produto/tecido", {
                tecido,
                excluido: "N",
                codproduto,
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });

            fetchDataTecido(codproduto);
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    }

    async function EditarTecido() {
        try {
            setLoading2(true);
            setError(null);
            await api.put("v1/cad/produto/tecido", {
                tecido,
                codtecido
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            fetchDataTecido(codproduto);
            toast.success('Edição feita com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    }

    async function CadastrarCor() {
        if (novacor) {
            try {
                setLoading2(true);
                setError(null);
                const response = await api.post("v1/cad/produto", {
                    descricao,
                    excluido: "N",
                    codassinante,
                    codusuario,
                },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },

                    });

                setCodProduto({ id: response.data.codproduto });
                setnovo(false);

                toast.success('Registro Salvo com Sucesso!');
            } catch (error) {
                console.error('Erro ao excluir dados:', error);
                setError('Erro ao tentar excluir os dados. Tente novamente.');
                toast.error('Ocorreu algum erro! ❌');
            } finally {
                setLoading2(false);
            }
        }

        try {
            setLoading2(true);
            setError(null);
            await api.post("v1/cad/produto/cor", {
                cor,
                excluido: "N",
                codproduto,
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            fetchDataCor(codproduto);
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    }

    async function EditarCor() {
        try {
            setLoading2(true);
            setError(null);
            await api.put("v1/cad/produto/cor", {
                cor,
                codcor
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            fetchDataCor(codproduto);
            toast.success('Edição feita com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }
    }

    const fetchDataFornecedor = async (query) => {
        try {
            const response = await api.get("/v1/busca/fornecedor", {
                params: {
                    busca: query,
                    codassinante,
                    codempresa
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            return response.data; // Retorna diretamente os dados da API

        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            toast.error('Ocorreu algum erro! ❌');
            return []; // Retorna um array vazio em caso de erro
        }
    };

    const handleAddFornecedor = () => {
        setnovofornecedor(true);
        setshowformfornecedor(true);

        entradaData.codfornecedor = 0;
        entradaData.nomefornecedor = "";
        setCodFornecedor(0);
        setTipoFornecedor('J')
        setNome('');
        setCPF('');
        setRazaoSocial('');
        setNomeFantasia('');
        setCNPJ('');
        setIE('');
        setCEP('');
        setEndereco('');
        setNumero('');
        setComplemento('');
        setBairro('');
        setCidade('');
        setUF('');
        setCodCidade('');
        setPais('Brasil');
        setCodPais('1058');
        setTelefone('');
        setWhatsApp('');
        setEmail('');
    };

    const fetchDataProduto = async (query) => {
        try {
            const response = await api.get("/v1/busca/produto", {
                params: {
                    busca: query,
                    codassinante,
                    codempresa
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            return response.data; // Retorna diretamente os dados da API

        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            toast.error('Ocorreu algum erro! ❌');
            return []; // Retorna um array vazio em caso de erro
        }
    };

    const handleSelectProduto = (item) => {
        if (!item || typeof item !== "object") {
            return;
        }

        // carrega dependências específicas do produto
        ListarTamanho(item.id);
        ListarTecido(item.id);

        // só armazena nos states auxiliares (não altera entradaData ainda)
        setCodProduto({ id: item.id, label: item.label });
        setTipo(item.tipo);
        setQtde(1);
    };

    const handleSelectTamanho = (e) => {
        const selectedCodTamanho = e.target.value;
        setCodTamanho(selectedCodTamanho);
    };

    const handleAddProduto = () => {
        setshowformproduto(true);
        setnovoproduto(true);

        setCodProduto({ id: 0 });
        setDescricao('');
    };

    function ListarTecido(codigo) {
        api
            .get("/v1/cad/produto/tecido", {
                params: {
                    codproduto: codigo
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setListaTecido(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ListarCor(codigo) {
        api
            .get("/v1/cad/produto/cor", {
                params: {
                    codtecido: codigo
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setListaCor(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ListarTamanho(codigo) {
        api
            .get("/v1/cad/produto/tamanho", {
                params: {
                    codproduto: codigo
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setListaTamanho(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function MenuItens() {
        if (entradaData?.tipo === 'C') {
            if (entradaData?.codfornecedor > 0) {
                setAbaAtiva("itens");
                setCodProduto({ id: 0, label: '', preco: 0 });
                setQtde(0);
                setCodTamanho(0);
                setCodTecido(0);
                setCor(0);
                setObservacao('');
            }
            else {
                alert("Informe os dados do fornecedor antes de informar os itens!");
            }
        } else if (entradaData?.tipo === 'F') {
            if (entradaData?.codfornecedor > 0) {
                setAbaAtiva("itens");
                setCodProduto({ id: 0, label: '', preco: 0 });
                setQtde(0);
                setPreco(0);
                setTotal(0);
                setCodTamanho(0);
                setCodTecido(0);
                setCor(0);
                setObservacao('');
            }
            else {
                alert("Informe os dados do fornecedor antes de informar os itens!");
            }
        } else {
            setAbaAtiva("itens");
            setCodProduto({ id: 0, label: '', preco: 0 });
            setQtde(0);
            setCodTamanho(0);
            setCodTecido(0);
            setCor(0);
            setObservacao('');
        }

        //logJsonNodes(entradaData);
    }

    const verificarSituacao = (item) => {
        if (item.situacao === "Pendente") {
            alert("Não será processado porque a situação está como Pendente.");
            return false;
        }

        // Situação ok
        return true;
    };

    async function Imprimir(item) {
        setLoading(true);

        try {
            const response = await api.get(`v1/imp/venda`, {
                responseType: "arraybuffer",
                params: {
                    codentrada: item.codentrada
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.click();
        } catch (error) {
            console.log("ops! ocorreu um erro: " + error);
        } finally {
            setLoading(false);
        }
    }

    const consultarCep = async () => {
        try {
            const cepLimpo = cep.replace(/\D/g, "");
            if (cepLimpo.length !== 8) {
                alert("CEP inválido!");
                return;
            }

            const { data } = await api.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);

            if (data.erro) {
                alert("CEP não encontrado!");
                return;
            }

            setEndereco(data.logradouro);
            setComplemento(data.complemento);
            setBairro(data.bairro);
            setCidade(data.localidade);
            setUF(data.uf);
            setCodCidade(data.ibge)
        } catch (error) {
            console.error("Erro ao consultar CEP:", error);
            alert("Não foi possível buscar o CEP.");
        }
    };

    const consultarCnpj = async () => {
        if (!cnpj || cnpj.length < 14) {
            alert("Informe um CNPJ válido!");
            return;
        }

        try {
            const { data } = await api.get(`https://brasilapi.com.br/api/cnpj/v1/${cnpj.replace(/\D/g, "")}`);


            setRazaoSocial(data.razao_social);
            setNomeFantasia(data.nome_fantasia);
            setIE(data.inscricao_estadual);
            setCEP(data.cep);
            setEndereco(data.logradouro);
            setNumero(data.numero);
            setBairro(data.bairro);
            setCidade(data.municipio);
            setUF(data.uf);


        } catch (error) {
            console.error(error);
            alert("Erro ao consultar CNPJ. Verifique se é válido.");
        }
    };

    const handleRemoveFile = async (itemIndex, fileIndex) => {
        const fileToRemove = entradaData?.itens[itemIndex]?.arquivos?.[fileIndex];

        if (!fileToRemove || !fileToRemove.key) {
            console.error("Arquivo não encontrado ou sem chave S3.");
            return;
        }

        try {
            setLoading(true);

            // 🔸 Caso seja um arquivo ainda não salvo no banco
            if (fileToRemove.codigo === 0) {
                setEntradaData((prev) => {
                    const updatedItens = [...prev.itens];
                    updatedItens[itemIndex] = {
                        ...updatedItens[itemIndex],
                        arquivos: updatedItens[itemIndex].arquivos.filter((_, i) => i !== fileIndex),
                    };
                    return { ...prev, itens: updatedItens };
                });

                toast.success("Arquivo removido com sucesso!");
                return;
            }

            // 🔹 Caso o arquivo já esteja salvo → chama o backend
            await api.delete("/v1/operacao/removeranexo", {
                params: {
                    tipo: "entrada",          // usado no Delphi para identificar a tabela
                    codigo: fileToRemove.codigo, // ID do registro de anexo
                    key: fileToRemove.key,    // caminho do arquivo no S3
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            // 🔹 Atualiza estado local removendo o arquivo
            setEntradaData((prev) => {
                const updatedItens = [...prev.itens];
                updatedItens[itemIndex] = {
                    ...updatedItens[itemIndex],
                    arquivos: updatedItens[itemIndex].arquivos.filter((_, i) => i !== fileIndex),
                };
                return { ...prev, itens: updatedItens };
            });

            toast.success("Arquivo removido com sucesso!");
        } catch (error) {
            console.error("Erro ao remover arquivo:", error);
            toast.error("Erro ao remover o arquivo ❌");
        } finally {
            setLoading(false);
        }
    };

    function logJsonNodes(obj, path = "") {
        if (typeof obj !== "object" || obj === null) {
            console.log(`${path}: ${obj}`);
            return;
        }

        if (Array.isArray(obj)) {
            obj.forEach((item, index) => {
                logJsonNodes(item, `${path}[${index}]`);
            });
        } else {
            Object.entries(obj).forEach(([key, value]) => {
                const newPath = path ? `${path}.${key}` : key;
                logJsonNodes(value, newPath);
            });
        }
    }

    return (
        <>
            <div className="app-container">
                <Sidebar />
                <main className="content-container">
                    <PopUp isOpen={isOpen} onClose={handleClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja excluir esse registro?</p>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUp>

                    <PopUpTamanho isOpen={isOpenTamanho} onClose={handleTamanhoClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja excluir esse tamanho?</p>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleTamanhoConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleTamanhoClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUpTamanho>

                    <PopUpTecido isOpen={isOpenTecido} onClose={handleTecidoClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja excluir esse tecido?</p>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleTecidoConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleTecidoClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUpTecido>

                    <PopUpCor isOpen={isOpenCor} onClose={handleCorClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja excluir esse cor?</p>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleCorConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleCorClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUpCor>

                    <Modal
                        isOpen={showform}
                        onRequestClose={() => setshowform(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-xl"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro </h2>}
                                <button type="button" className="btn-close" onClick={() => setshowform(false)}></button>
                            </div>

                            {/* Indicador de Progresso */}
                            <div className="progress mt-2">
                                <div className="progress-bar" role="progressbar" style={{ width: `${progresso}%` }}>
                                    {Math.round(progresso)}%
                                </div>
                            </div>

                            {/* Abas */}
                            <ul className="nav nav-tabs mt-3">
                                <li className="nav-item">
                                    <button className={`nav-link ${abaAtiva === "cabecalho" ? "active" : ""}`} onClick={() => setAbaAtiva("cabecalho")}>
                                        Cabeçalho da Entrada
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button className={`nav-link ${abaAtiva === "itens" ? "active" : ""}`} onClick={() => MenuItens()}>
                                        Itens da Entrada
                                    </button>
                                </li>
                            </ul>

                            <div className="modal-body">
                                {abaAtiva === "cabecalho" && (
                                    <form>
                                        <div className='row'>
                                            <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2'>
                                                <div className="form-floating">
                                                    <select
                                                        className="form-select"
                                                        id="tipo"
                                                        value={entradaData?.tipo || ''}
                                                        onChange={(e) => setEntradaData(prev => ({ ...prev, tipo: e.target.value }))}
                                                    >
                                                        <option value="C">COMPRA</option>
                                                        <option value="F">PEDIDO DE COMPRA</option>
                                                        <option value="I">INVENTÁRIO</option>
                                                        <option value="P">PRODUÇÃO</option>
                                                    </select>
                                                    <label htmlFor="crt">Tipo</label>
                                                </div>
                                            </div>

                                            {(entradaData?.tipo === 'C' || entradaData?.tipo === 'F') && (
                                                <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <AutoComplete1
                                                            fetchData={fetchDataFornecedor}
                                                            onSelect={(item) =>
                                                                setEntradaData(prev => ({
                                                                    ...prev,
                                                                    codfornecedor: item?.id || 0,
                                                                    nomefornecedor: item?.label || ""
                                                                }))
                                                            }
                                                            onAdd={handleAddFornecedor}
                                                            txtLabel={"Fornecedor"}
                                                            initialValue={
                                                                entradaData?.codfornecedor
                                                                    ? { id: entradaData.codfornecedor, label: entradaData.nomefornecedor }
                                                                    : null
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                        </div>
                                    </form>
                                )}

                                {abaAtiva === "itens" && (
                                    <div className="container-fluid p-0">

                                        {/* Campos para adicionar item */}
                                        {entradaData?.tipo === 'F' ? (
                                            <div className="row g-2 align-items-end mb-3">
                                                <div className="col-md-3">
                                                    <AutoComplete3
                                                        fetchData={fetchDataProduto}
                                                        onSelect={handleSelectProduto}
                                                        onAdd={handleAddProduto}
                                                        txtLabel={"Produto"}
                                                        initialValue={codproduto}
                                                    />

                                                </div>

                                                <div className="col-md-1">
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="number"
                                                            placeholder="Qtde"
                                                            value={qtde}
                                                            onChange={(e) => {
                                                                const quantidade = isNaN(e.target.valueAsNumber) ? 0 : e.target.valueAsNumber;
                                                                setQtde(quantidade);
                                                                setTotal(quantidade * preco);
                                                            }}
                                                        />
                                                        <label htmlFor="qtde">Qtde</label>
                                                    </div>
                                                </div>

                                                <div className="col-md-1">
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="number"
                                                            placeholder="Preço"
                                                            value={preco}
                                                            onChange={(e) => {
                                                                const apreco = isNaN(e.target.valueAsNumber) ? 0 : e.target.valueAsNumber;
                                                                setPreco(apreco);
                                                                setTotal(qtde * apreco);
                                                            }}
                                                        />
                                                        <label htmlFor="qtde">Preço</label>
                                                    </div>
                                                </div>

                                                <div className="col-md-1">
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="number"
                                                            placeholder="Total"
                                                            value={total}
                                                            disabled
                                                        />
                                                        <label htmlFor="qtde">Total</label>
                                                    </div>
                                                </div>

                                                {tipo === 'P' && (
                                                    <>
                                                        <div className="col-md-2">
                                                            <div className="form-floating">
                                                                <select
                                                                    className="form-select"
                                                                    value={codtamanho}
                                                                    onChange={handleSelectTamanho}
                                                                >
                                                                    <option value="0">Tamanho</option>
                                                                    {listaTamanho.map(tam => (
                                                                        <option key={tam.codtamanho} value={tam.codtamanho}>{tam.tamanho}</option>
                                                                    ))}
                                                                </select>
                                                                <label htmlFor="tamanho">Tamanho</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-floating">
                                                                <select
                                                                    className="form-select"
                                                                    value={codtecido}
                                                                    onChange={(e) => {
                                                                        setCodTecido(e.target.value);
                                                                        ListarCor(e.target.value);
                                                                    }}
                                                                >
                                                                    <option value="0">Tecido</option>
                                                                    {listaTecido.map(tec => (
                                                                        <option key={tec.codtecido} value={tec.codtecido}>{tec.tecido}</option>
                                                                    ))}
                                                                </select>
                                                                <label htmlFor="tecido">Tecido</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-floating">
                                                                <select
                                                                    className="form-select"
                                                                    value={codcor}
                                                                    onChange={(e) => setCodCor(e.target.value)}
                                                                    disabled={codtecido === 0}
                                                                >
                                                                    <option value="0">Cor</option>
                                                                    {listaCor.map(c => (
                                                                        <option key={c.codcor} value={c.codcor}>{c.cor}</option>
                                                                    ))}
                                                                </select>
                                                                <label htmlFor="cor">Cor</label>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                <div className="col-md-10">
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="observacao"
                                                            value={observacao}
                                                            onChange={(e) => setObservacao(e.target.value)}
                                                        />
                                                        <label htmlFor="qtde">Observação</label>
                                                    </div>
                                                </div>

                                                <div className="col-md-1 d-grid">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success"
                                                        onClick={handleAddNovoProduto}
                                                    >
                                                        ADD
                                                    </button>

                                                </div>
                                            </div>
                                        ) : (
                                            <div className="row g-2 align-items-end mb-3">
                                                <div className="col-md-3">
                                                    <AutoComplete3
                                                        fetchData={fetchDataProduto}
                                                        onSelect={handleSelectProduto}
                                                        onAdd={handleAddProduto}
                                                        txtLabel={"Produto"}
                                                        initialValue={codproduto}
                                                    />

                                                </div>

                                                <div className="col-md-1">
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="number"
                                                            placeholder="Qtde"
                                                            value={qtde}
                                                            onChange={(e) => {
                                                                const quantidade = isNaN(e.target.valueAsNumber) ? 0 : e.target.valueAsNumber;
                                                                setQtde(quantidade);
                                                            }}
                                                        />
                                                        <label htmlFor="qtde">Qtde</label>
                                                    </div>
                                                </div>

                                                {tipo === 'P' && (
                                                    <>
                                                        <div className="col-md-2">
                                                            <div className="form-floating">
                                                                <select
                                                                    className="form-select"
                                                                    value={codtamanho}
                                                                    onChange={handleSelectTamanho}
                                                                >
                                                                    <option value="0">Tamanho</option>
                                                                    {listaTamanho.map(tam => (
                                                                        <option key={tam.codtamanho} value={tam.codtamanho}>{tam.tamanho}</option>
                                                                    ))}
                                                                </select>
                                                                <label htmlFor="tamanho">Tamanho</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-floating">
                                                                <select
                                                                    className="form-select"
                                                                    value={codtecido}
                                                                    onChange={(e) => {
                                                                        setCodTecido(e.target.value);
                                                                        ListarCor(e.target.value);
                                                                    }}
                                                                >
                                                                    <option value="0">Tecido</option>
                                                                    {listaTecido.map(tec => (
                                                                        <option key={tec.codtecido} value={tec.codtecido}>{tec.tecido}</option>
                                                                    ))}
                                                                </select>
                                                                <label htmlFor="tecido">Tecido</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-floating">
                                                                <select
                                                                    className="form-select"
                                                                    value={codcor}
                                                                    onChange={(e) => setCodCor(e.target.value)}
                                                                    disabled={codtecido === 0}
                                                                >
                                                                    <option value="0">Cor</option>
                                                                    {listaCor.map(c => (
                                                                        <option key={c.codcor} value={c.codcor}>{c.cor}</option>
                                                                    ))}
                                                                </select>
                                                                <label htmlFor="cor">Cor</label>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                <div className="col-md-10">
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="observacao"
                                                            value={observacao}
                                                            onChange={(e) => setObservacao(e.target.value)}
                                                        />
                                                        <label htmlFor="qtde">Observação</label>
                                                    </div>
                                                </div>

                                                <div className="col-md-1 d-grid">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success"
                                                        onClick={handleAddNovoProduto}
                                                    >
                                                        ADD
                                                    </button>

                                                </div>
                                            </div>
                                        )}

                                        {/* Resumo rápido */}
                                        <div className="alert alert-info py-2 mb-3">
                                            <strong>Total de Itens:</strong> {entradaData?.itens?.length || 0}

                                            {entradaData?.tipo === 'F' && (
                                                <>
                                                    &nbsp; | &nbsp;
                                                    <strong>Total Agregado:</strong>{" "}
                                                    {entradaData?.itens?.reduce((total, item) => {
                                                        return total + (Number(item.total) || 0);
                                                    }, 0).toLocaleString("pt-BR", {
                                                        style: "currency",
                                                        currency: "BRL",
                                                    })}
                                                </>
                                            )}
                                        </div>


                                        {/* Lista local de itens */}
                                        <table className="table table-sm table-hover align-middle">
                                            <thead>
                                                <tr>
                                                    <th>SKU</th>
                                                    <th>Produto</th>
                                                    <th>Qtde</th>
                                                    <th>Tamanho</th>
                                                    <th>Tecido</th>
                                                    <th>Cor</th>
                                                    <th>Anexos</th>
                                                    <th></th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {entradaData.itens.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="8" className="text-center text-muted">
                                                            Nenhum item adicionado
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    entradaData.itens.map((item, idx) => (
                                                        <tr key={idx}>
                                                            <td>{item.sku}</td>

                                                            {/* Produto e observação */}
                                                            <td>
                                                                <div>
                                                                    {item.codproduto ? item.codproduto : ''}
                                                                    {item.nomeProduto
                                                                        ? ` - ${item.nomeProduto}`
                                                                        : ''}
                                                                </div>

                                                                {item.observacao?.trim() && (
                                                                    <div
                                                                        className="mt-1"
                                                                        style={{
                                                                            color: '#b45309',
                                                                            fontSize: '12px',
                                                                            fontStyle: 'italic',
                                                                            whiteSpace: 'normal',
                                                                            overflowWrap: 'anywhere'
                                                                        }}
                                                                    >
                                                                        <strong>Obs.:</strong>{' '}
                                                                        {item.observacao}
                                                                    </div>
                                                                )}
                                                            </td>

                                                            <td>{item.qtde}</td>
                                                            <td>{item.tamanho || '-'}</td>
                                                            <td>{item.tecido || '-'}</td>
                                                            <td>{item.cor || '-'}</td>

                                                            {/* Anexos */}
                                                            <td>
                                                                <div className="d-flex flex-wrap gap-2">
                                                                    {item.arquivos?.map((arquivo, i) => (
                                                                        <div
                                                                            key={i}
                                                                            className="position-relative border rounded"
                                                                            style={{
                                                                                width: '50px',
                                                                                height: '50px'
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={arquivo.url}
                                                                                alt={arquivo.nome}
                                                                                className="img-fluid w-100 h-100 rounded"
                                                                                style={{
                                                                                    objectFit: 'cover',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                                onClick={() =>
                                                                                    window.open(
                                                                                        arquivo.url,
                                                                                        '_blank'
                                                                                    )
                                                                                }
                                                                            />

                                                                            <button
                                                                                type="button"
                                                                                className="btn-close position-absolute top-0 end-0"
                                                                                style={{
                                                                                    backgroundColor: 'white'
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleRemoveFile(idx, i)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    ))}

                                                                    {/* Botão para adicionar anexo */}
                                                                    <div
                                                                        className="d-flex align-items-center justify-content-center border rounded bg-light"
                                                                        style={{
                                                                            width: '50px',
                                                                            height: '50px',
                                                                            cursor: 'pointer'
                                                                        }}
                                                                        onClick={() =>
                                                                            document
                                                                                .getElementById(`fileInput-${idx}`)
                                                                                .click()
                                                                        }
                                                                    >
                                                                        <i className="fas fa-plus text-muted"></i>
                                                                    </div>
                                                                </div>

                                                                {/* Input escondido */}
                                                                <input
                                                                    id={`fileInput-${idx}`}
                                                                    type="file"
                                                                    className="d-none"
                                                                    multiple
                                                                    accept="image/*"
                                                                    onChange={(e) =>
                                                                        handleFileUpload(e, idx)
                                                                    }
                                                                />
                                                            </td>

                                                            {/* Excluir item */}
                                                            <td>
                                                                <button
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    onClick={async () => {
                                                                        const currentItem =
                                                                            entradaData.itens[idx];

                                                                        if (novo) {
                                                                            setEntradaData(prev => {
                                                                                const novosItens =
                                                                                    prev.itens.filter(
                                                                                        (_, i) => i !== idx
                                                                                    );

                                                                                const novoTotal =
                                                                                    novosItens.reduce(
                                                                                        (acc, item) =>
                                                                                            acc +
                                                                                            (Number(item.total) || 0),
                                                                                        0
                                                                                    );

                                                                                return {
                                                                                    ...prev,
                                                                                    itens: novosItens,
                                                                                    total: novoTotal
                                                                                };
                                                                            });
                                                                        } else {
                                                                            try {
                                                                                setLoading(true);

                                                                                await api.delete(
                                                                                    '/v1/operacao/entrada/entradaproduto',
                                                                                    {
                                                                                        params: {
                                                                                            codentradaproduto:
                                                                                                currentItem.codentradaproduto
                                                                                        },
                                                                                        headers: {
                                                                                            Authorization:
                                                                                                `Bearer ${accessKey}`
                                                                                        }
                                                                                    }
                                                                                );

                                                                                setEntradaData(prev => {
                                                                                    const novosItens =
                                                                                        prev.itens.filter(
                                                                                            (_, i) => i !== idx
                                                                                        );

                                                                                    const novoTotal =
                                                                                        novosItens.reduce(
                                                                                            (acc, item) =>
                                                                                                acc +
                                                                                                (Number(item.total) || 0),
                                                                                            0
                                                                                        );

                                                                                    return {
                                                                                        ...prev,
                                                                                        itens: novosItens,
                                                                                        total: novoTotal
                                                                                    };
                                                                                });

                                                                                toast.success(
                                                                                    'Item excluído com sucesso!'
                                                                                );
                                                                            } catch (error) {
                                                                                console.error(
                                                                                    'Erro ao excluir item:',
                                                                                    error
                                                                                );
                                                                                toast.error(
                                                                                    'Erro ao excluir item ❌'
                                                                                );
                                                                            } finally {
                                                                                setLoading(false);
                                                                            }
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>

                                    </div>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowform(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={Salvar} disabled={entradaData.itens?.length === 0}>
                                    Salvar
                                </button>

                            </div>
                        </div>
                    </Modal>

                    <ModalFornecedor
                        isOpen={showformfornecedor}
                        onRequestClose={() => setshowformfornecedor(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-xl"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novofornecedor ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowformfornecedor(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-group">
                                                <label className="form-label">Tipo de Fornecedor</label>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="pessoaJuridica"
                                                        name="tipoFornecedor"
                                                        value="J"
                                                        checked={tipofornecedor === "J"}
                                                        onChange={(e) => setTipoFornecedor(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="pessoaJuridica">
                                                        Pessoa Jurídica
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="pessoaFisica"
                                                        name="tipoFornecedor"
                                                        value="F"
                                                        checked={tipofornecedor === "F"}
                                                        onChange={(e) => setTipoFornecedor(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="pessoaFisica">
                                                        Pessoa Física
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        {tipofornecedor === 'J' ?
                                            (<>
                                                <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="razaosocial"
                                                            value={razaosocial}
                                                            onChange={(e) => setRazaoSocial(e.target.value)}
                                                        />
                                                        <label htmlFor="razaosocial">Razão Social</label>
                                                    </div>
                                                </div>
                                                <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="nomefantasia"
                                                            value={nomefantasia}
                                                            onChange={(e) => setNomeFantasia(e.target.value)}
                                                        />
                                                        <label htmlFor="nomefantasia">Nome Fantasia</label>
                                                    </div>
                                                </div>
                                                <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating input-group">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="CNPJ"
                                                            value={cnpj}
                                                            onChange={(e) => setCNPJ(e.target.value)}
                                                        />
                                                        <label htmlFor="cnpj">CNPJ</label>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-secondary"
                                                            onClick={consultarCnpj}
                                                        >
                                                            <i className="fa fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="ie"
                                                            value={ie}
                                                            onChange={(e) => setIE(e.target.value)}
                                                        />
                                                        <label htmlFor="ie">Ins. Estadual</label>
                                                    </div>
                                                </div>
                                            </>
                                            )
                                            :
                                            (<>
                                                <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="nome"
                                                            value={nome}
                                                            onChange={(e) => setNome(e.target.value)}
                                                        />
                                                        <label htmlFor="nome">Nome</label>
                                                    </div>
                                                </div>
                                                <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="cpf"
                                                            value={cpf}
                                                            onChange={(e) => setCPF(e.target.value)}
                                                        />
                                                        <label htmlFor="cpf">CPF</label>
                                                    </div>
                                                </div>
                                            </>)
                                        }

                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2">
                                            <div className="form-floating input-group">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="cep"
                                                    id="cep"
                                                    value={cep}
                                                    onChange={(e) => setCEP(e.target.value)}
                                                />
                                                <label htmlFor="cep">CEP</label>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary"
                                                    onClick={consultarCep}
                                                >
                                                    <i className="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div className='col-xl-5 col-lg-5 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="endereco"
                                                    id="endereco"
                                                    value={endereco}
                                                    onChange={(e) => setEndereco(e.target.value)}
                                                />
                                                <label htmlFor="endereco">Endereço</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-1 col-lg-1 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="numero"
                                                    id="numero"
                                                    value={numero}
                                                    onChange={(e) => setNumero(e.target.value)}
                                                />
                                                <label htmlFor="numero">Núm.</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="complemento"
                                                    id="complemento"
                                                    value={complemento}
                                                    onChange={(e) => setComplemento(e.target.value)}
                                                />
                                                <label htmlFor="complemento">Complemento</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="bairro"
                                                    id="bairro"
                                                    value={bairro}
                                                    onChange={(e) => setBairro(e.target.value)}
                                                />
                                                <label htmlFor="bairro">Bairro</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-5 col-lg-5 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="cidade"
                                                    id="cidade"
                                                    value={cidade}
                                                    onChange={(e) => setCidade(e.target.value)}
                                                />
                                                <label htmlFor="cidade">Cidade</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-1 col-lg-1 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="uf"
                                                    id="uf"
                                                    value={uf}
                                                    onChange={(e) => setUF(e.target.value)}
                                                />
                                                <label htmlFor="uf">UF</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="codcidade"
                                                    id="codcidade"
                                                    value={codcidade}
                                                    onChange={(e) => setCodCidade(e.target.value)}
                                                />
                                                <label htmlFor="codcidade">Cód. IBGE Cida.</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-5 col-lg-5 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="pais"
                                                    id="pais"
                                                    value={pais}
                                                    onChange={(e) => setPais(e.target.value)}
                                                />
                                                <label htmlFor="pais">País</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="codpais"
                                                    id="codpais"
                                                    value={codpais}
                                                    onChange={(e) => setCodPais(e.target.value)}
                                                />
                                                <label htmlFor="codpais">Cód. IBGE País</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="telefone"
                                                    id="telefone"
                                                    value={telefone}
                                                    onChange={(e) => setTelefone(e.target.value)}
                                                />
                                                <label htmlFor="telefone">Telefone</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="whatsapp"
                                                    id="whatsapp"
                                                    value={whatsapp}
                                                    onChange={(e) => setWhatsApp(e.target.value)}
                                                />
                                                <label htmlFor="whatsapp">WhatsApp</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="email"
                                                    id="email"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                                <label htmlFor="email">E-mail</label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowformfornecedor(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={SalvarFornecedor}>
                                    Salvar
                                </button>

                            </div>
                        </div>
                    </ModalFornecedor>

                    <ModalProduto
                        isOpen={showformproduto}
                        onRequestClose={() => setshowformproduto(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-xl"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novoproduto ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowformproduto(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="descricao"
                                                    value={descricao}
                                                    onChange={(e) => setDescricao(e.target.value)}
                                                />
                                                <label htmlFor="descricao">Modelo</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div>
                                                <button className='btn btn-outline-primary w-100' type='button' onClick={handleAddTamanho}>Adicionar Tamanho</button>
                                            </div>

                                            <div>
                                                <TableTamanho
                                                    columns={columnsTamanho}
                                                    data={dataTamanho}
                                                    onEdit={handleTamanhoEdit}
                                                    onDelete={handleTamanhoOpen}
                                                />
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div>
                                                <button className='btn btn-outline-primary w-100' type='button' onClick={handleAddTecido}>Adicionar Tecido</button>
                                            </div>

                                            <div>
                                                <TableTecido
                                                    columns={columnsTecido}
                                                    data={dataTecido}
                                                    onEdit={handleTecidoEdit}
                                                    onDelete={handleTecidoOpen}
                                                />
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div>
                                                <button className='btn btn-outline-primary w-100' type='button' onClick={handleAddCor}>Adicionar Cor</button>
                                            </div>

                                            <div>
                                                <TableCor
                                                    columns={columnsCor}
                                                    data={dataCor}
                                                    onEdit={handleCorEdit}
                                                    onDelete={handleCorOpen}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowformproduto(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={SalvarProduto}>
                                    Salvar
                                </button>

                            </div>
                        </div>
                    </ModalProduto>

                    <ModalTamanho
                        isOpen={showformtamanho}
                        onRequestClose={() => setshowformtamanho(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-lg"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novotamanho ? <h2>Novo Tamanho</h2> : <h2>Editando Tamanho</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowformtamanho(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="tamanho"
                                                    value={tamanho}
                                                    onChange={(e) => setTamanho(e.target.value)}
                                                />
                                                <label htmlFor="tamanho">Tamanho</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <hr />
                                        <h3 className='text-center'>Preço de produção</h3>
                                        <hr />
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="serraria"
                                                    value={serraria}
                                                    onChange={(e) => setSerraria(e.target.value)}
                                                />
                                                <label htmlFor="serraria">Serraria</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="montagemgrade"
                                                    value={montagemgrade}
                                                    onChange={(e) => setMontagemGrade(e.target.value)}
                                                />
                                                <label htmlFor="montagemgrade">Montagem Grade</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="marcenaria"
                                                    value={marcenaria}
                                                    onChange={(e) => setMarcenaria(e.target.value)}
                                                />
                                                <label htmlFor="marcenaria">Marcenaria</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="colagemespuma"
                                                    value={colagemespuma}
                                                    onChange={(e) => setColagemEspuma(e.target.value)}
                                                />
                                                <label htmlFor="colagemespuma">Colagem Espuma</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="cortetecido"
                                                    value={cortetecido}
                                                    onChange={(e) => setCorteTecido(e.target.value)}
                                                />
                                                <label htmlFor="cortetecido">Corte Tecido</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="costura"
                                                    value={costura}
                                                    onChange={(e) => setCostura(e.target.value)}
                                                />
                                                <label htmlFor="costura">Costura</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="enchimentoalmofada"
                                                    value={enchimentoalmofada}
                                                    onChange={(e) => setEnchimentoAlmofada(e.target.value)}
                                                />
                                                <label htmlFor="enchimentoalmofada">Enchimento Almofada</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="colagemtecido"
                                                    value={colagemtecido}
                                                    onChange={(e) => setColagemTecido(e.target.value)}
                                                />
                                                <label htmlFor="colagemtecido">Colagem Tecido</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="coberta"
                                                    value={coberta}
                                                    onChange={(e) => setCoberta(e.target.value)}
                                                />
                                                <label htmlFor="coberta">Coberta</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="entrega"
                                                    value={entrega}
                                                    onChange={(e) => setEntrega(e.target.value)}
                                                />
                                                <label htmlFor="entrega">Entrega</label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowformtamanho(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={SalvarTamanho}>
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </ModalTamanho>

                    <ModalTecido
                        isOpen={showformtecido}
                        onRequestClose={() => setshowformtecido(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-sm"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novotecido ? <h2>Novo Tecido</h2> : <h2>Editando Tecido</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowformtecido(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="tecido"
                                                    value={tecido}
                                                    onChange={(e) => setTecido(e.target.value)}
                                                />
                                                <label htmlFor="tecido">Tecido</label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowformtecido(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={SalvarTecido}>
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </ModalTecido>

                    <ModalCor
                        isOpen={showformcor}
                        onRequestClose={() => setshowformcor(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-sm"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novacor ? <h2>Nova Cor</h2> : <h2>Editando Cor</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowformcor(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="cor"
                                                    value={cor}
                                                    onChange={(e) => setCor(e.target.value)}
                                                />
                                                <label htmlFor="cor">Cor</label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowformcor(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={() => SalvarCor()}>
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </ModalCor>

                    <div className="container-fluid py-4 d-flex flex-column" style={{ minHeight: '100vh' }}>
                        <Title text="Lançamento de Entrada de Produto" icon="user" />
                        <Description text="Operação para registrar dos produtos para abastecer o estoque da empresa" />

                        <div className="row mb-3">
                            <div className="col-xl-6 col-lg-5 col-md-5 col-sm-12">
                                <SearchField
                                    value={search}
                                    onChange={setSearch}
                                    placeholder="Buscar entrada por: Código ou Fornecedor"
                                />
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-3 col-sm-12">
                                <DuasDatas
                                    value1={dt1}
                                    onChange1={setdt1}
                                    value2={dt2}
                                    onChange2={setdt2}
                                />
                            </div>

                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 text-center">
                                <AddButton onClick={handleAdd} text="Nova entrada" disabled={!podeInserir("/ope/entradaprodutos")} />
                            </div>
                        </div>

                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}

                        {loading2 && <Aguarte />}

                        {/* Corpo principal com flex-grow */}

                        <div className="flex-grow-1 d-flex flex-column">
                            {loading ? (
                                <div className="text-center py-4 flex-grow-1 d-flex align-items-center justify-content-center">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Carregando...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-wrapper flex-grow-1 d-flex flex-column">
                                    <Table
                                        columns={columns}
                                        data={data}
                                        onEdit={handleEdit} // Passa a função diretamente
                                        isEditDisabled={(item) => {
                                            return item.situacao === "Faturado" || !podeEditar("/ope/entradaprodutos");
                                        }}
                                        onDelete={handleOpen}
                                        isDeleteDisabled={() => !podeExcluir("/ope/entradaprodutos")}
                                        menuActions={menuOptions}
                                        // Adiciona uma nova propriedade para a lógica de desabilitar

                                        columnTextColors={{
                                            situacao: (value) =>
                                                value === "Faturado" ? "green" :
                                                    value === "Sem Faturamento" ? "red" :
                                                        "inherit",
                                        }}
                                    />
                                </div>
                            )}
                        </div>

                        {/* Pagination no rodapé */}
                        <Pagination
                            currentPage={currentPage}
                            totalPages={pagination.totalPages}
                            onPageChange={setCurrentPage}
                            perPage={perPage}
                            onPerPageChange={handlePerPageChange}
                            total={pagination.total}
                        />

                    </div>
                </main>
            </div>
        </>
    );
};

export default OpeEntradaMercadoria;